// /embed/prisindex-2026 — inbäddningsbar widget av prisindexet.
// Syfte (authority): varje inbäddning på en annan sajt ger en synlig
// källhänvisning tillbaka till fenny.se. Sidan är noindex — den ska aldrig
// konkurrera med studien själv i sök.

import { createFileRoute } from "@tanstack/react-router";
import {
  CITY_INDEX,
  FORMAT_INDEX,
  PRISINDEX_LICENSE,
  PRISINDEX_LICENSE_URL,
  PRISINDEX_PATH,
  PRISINDEX_PUBLISHED,
  PRISINDEX_TITLE,
  range,
} from "@/lib/data/prisindex-2026";
import { abs } from "@/lib/seo/constants";

export const Route = createFileRoute("/embed_/prisindex-2026")({
  head: () => ({
    meta: [
      { title: `${PRISINDEX_TITLE} — inbäddad widget | Fenny` },
      { name: "robots", content: "noindex,follow" },
      {
        name: "description",
        content:
          "Inbäddningsbar version av Fennys prisindex för filmproduktion 2026.",
      },
    ],
    links: [{ rel: "canonical", href: abs(PRISINDEX_PATH) }],
  }),
  component: EmbedPrisindex,
});

function EmbedPrisindex() {
  return (
    <div className="bg-background p-4 text-foreground">
      <div className="mx-auto max-w-2xl space-y-3">
        <div>
          <h1 className="text-lg font-semibold">{PRISINDEX_TITLE}</h1>
          <p className="text-xs text-muted-foreground">
            Produktionskostnad exklusive mediaköp · uppdaterad{" "}
            {PRISINDEX_PUBLISHED} · {PRISINDEX_LICENSE}
          </p>
        </div>

        <div className="overflow-hidden rounded-lg border border-border">
          <table className="w-full text-left text-xs">
            <thead className="bg-muted/40">
              <tr>
                <th className="px-3 py-2">Format</th>
                <th className="px-3 py-2">Längd</th>
                <th className="px-3 py-2">Prisspann 2026</th>
              </tr>
            </thead>
            <tbody>
              {FORMAT_INDEX.map((f) => (
                <tr key={f.format} className="border-t border-border">
                  <td className="px-3 py-2 font-medium">{f.format}</td>
                  <td className="px-3 py-2 text-muted-foreground">{f.length}</td>
                  <td className="px-3 py-2 text-muted-foreground">
                    {range(f.min, f.max)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex flex-wrap gap-2 text-xs text-muted-foreground">
          {CITY_INDEX.map((c) => (
            <span
              key={c.city}
              className="rounded-full border border-border px-2 py-1"
            >
              {c.city} index {c.index}
            </span>
          ))}
        </div>

        <p className="text-xs text-muted-foreground">
          Källa:{" "}
          <a
            href={abs(PRISINDEX_PATH)}
            target="_blank"
            rel="noopener"
            className="underline"
          >
            Fenny — {PRISINDEX_TITLE}
          </a>{" "}
          ·{" "}
          <a
            href={PRISINDEX_LICENSE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="underline"
          >
            {PRISINDEX_LICENSE}
          </a>
        </p>
      </div>
    </div>
  );
}
